import { QueryClient } from '@tanstack/svelte-query';

let client: QueryClient | undefined;

export function getQueryClient(): QueryClient {
  if (!client) {
    client = new QueryClient({
      defaultOptions: {
        queries: {
          staleTime: 0,
          retry: 1,
          refetchOnWindowFocus: false
        }
      }
    });
  }
  return client;
}
